<template>
  <v-dialog v-model="visible" persistent scrollable max-width="500px" content-class="pay-receipt-dialog" v-if="receipt">
    <v-card>
      <v-card-title style="background-color: #1577da; font-weight: bold; color: white">
        <span class="text-h5" style="font-weight: bold">Plati račun</span>
        <v-spacer></v-spacer>
        <v-btn icon dark @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-form ref="payReceiptForm" v-model="valid" @submit.prevent="submit">
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <div class="text-body-2 grey--text text--darken-1">
                  {{ $t('$vuetify.receipts.receiptIssueDate') }}: <strong>{{ receiptIssueDate }}</strong>
                </div>
              </v-col>

              <v-col cols="12">
                <v-text-field
                  v-model="paymentDate"
                  :label="$t('$vuetify.receipts.receiptPaymentDate')"
                  type="date"
                  :max="new Date().toISOString().substr(0, 10)"
                  :rules="[rules.req]"
                  required
                  dense
                  outlined
                ></v-text-field>
              </v-col>

              <v-col cols="12">
                <v-text-field
                  :label="$t('$vuetify.journalNum')"
                  v-model="journalNum"
                  dense
                  outlined
                ></v-text-field>
              </v-col>

              <v-col cols="12">
                <v-textarea
                  :label="$t('$vuetify.note')"
                  v-model="note"
                  rows="3"
                  auto-grow
                  outlined
                ></v-textarea>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions class="pr-6 pl-6 pb-4">
          <v-spacer></v-spacer>
          <v-btn class="btn infoButton mr-3" @click="close" :disabled="submitting">
            {{ $t('$vuetify.close') }}
          </v-btn>
          <v-btn
            class="btn successButton"
            type="submit"
            :loading="submitting"
            :disabled="submitting || !valid"
          >
            Plati račun
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import rules from '@/plugins/rules'
import { clone, toISOLocal } from '@/plugins/utils'
import { df, auth } from '@/plugins/firebase'
import state from '@/state'
import { v4 as uuidv4 } from 'uuid'
import requestChecker from '@/mixins/requestChecker'

export default {
  inject: ['showMsgBox'],
  mixins: [requestChecker],
  data: function () {
    return {
      visible: false,
      valid: false,
      submitting: false,
      receipt: undefined,
      paymentDate: '',
      rules: {
        req: rules.req()
      },
      note: '',
      journalNum: ''
    }
  },
  computed: {
    receiptIssueDate () {
      return new Date(
        toISOLocal(
          new Date(this.receipt.issue_date_time * 1000 || new Date().getTime())
        )
      ).toLocaleDateString('hr-HR')
    }
  },
  methods: {
    open (receipt) {
      if (!receipt) return
      this.receipt = clone(receipt)
      const yesterday = new Date()
      yesterday.setDate(yesterday.getDate() - 1)
      this.paymentDate = yesterday.toISOString().substr(0, 10)
      this.note = ''
      this.journalNum = ''
      const reqParams = { status_info: this.note }
      this.registerRequestParams(reqParams)
      this.visible = true
    },
    close () {
      this.note = ''
      this.journalNum = ''
      this.paymentDate = ''
      this.submitting = false
      this.visible = false
    },
    submit () {
      if (!this.$refs.payReceiptForm.validate()) return
      try {
        const paymentDate = (new Date(this.paymentDate).getTime() / 1000).toFixed(0)

        const reqId = uuidv4()
        const payload = {
          action: {
            operation: 'update',
            entity: 'receipt',
            resource_id: this.receipt.id,
            params: {
              company_id: state.getCurrentCompany().id,
              date: parseInt(paymentDate),
              status: 'PAID',
              status_info: this.note,
              journal_number: this.journalNum
            }
          }
        }

        const cleanParams = this.getCleanParams(payload.action.params)
        Object.keys(cleanParams).forEach((key) => {
          delete payload.action.params[key]
        })

        this.submitting = true
        df.doc(`request/${reqId}`)
          .set({
            msg_id: reqId,
            user_id: `${auth.currentUser.uid}`,
            device_id: 'web',
            created: `${new Date().getTime()}`,
            type: 'receipt',
            payload: btoa(unescape(encodeURIComponent(JSON.stringify(payload))))
          })
          .then(() => {
            this.$emit('receiptEdit', this.receipt)
            this.close()
          })
          .catch((error) => {
            throw new Error(error)
          })
          .finally(() => {
            this.submitting = false
          })
      } catch (err) {
        this.showMsgBox({
          text: err,
          actions: ['cancel'],
          cancelBtnText: 'OK'
        })
      }
    }
  }
}
</script>

<style scoped>
.v-dialog__content >>> .pay-receipt-dialog {
  border-radius: 20px !important;
}
</style>
